import {AutoCompleteService} from 'ionic2-auto-complete';
import { Http } from '@angular/http';
import {Injectable} from "@angular/core";
import 'rxjs/add/operator/map'
import { ParplatzData } from './pp-data';
@Injectable()
export class CompletePPService implements AutoCompleteService {
  labelAttribute = "kurzname";

  constructor(private ppData:ParplatzData) {

  }
  getResults(keyword:string) {
    return this.ppData.data.filter(item => item.kurzname.toLowerCase().includes(keyword.toLowerCase()));
    /*
    return this.http.get("https://restcountries.eu/rest/v1/name/"+keyword)
      .map(
        result =>
        {
          return result.json()
            .filter(item => item.name.toLowerCase().startsWith(keyword.toLowerCase()) )
        });
        */
  }
}


// WEBPACK FOOTER //
// ./src/providers/epautocomplete-service.ts